/* ===================================
  Set/Get Cookie Functions
=================================== */
function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/; SameSite=None; Secure";
}
function getCookie(cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded .split('; ');
  let res;
  cArr.forEach(val => {
      if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res;
}

/* ===================================
  Cookie Policy Modal
=================================== */
const privacyBanner = document.getElementById("RolexConsent");
const updateCookieConsentLink = document.getElementById("updateCookieConsent");
const consentAccept = document.getElementById("RolexConsentAccept");
const consentDecline = document.getElementById("RolexConsentDecline");
const privacyBannerClose = document.getElementById("RolexConsentClose");
const bodyElement = document.body;
  var isRolex = bodyElement.classList.contains('rlx');

var privacyBannerCookie = getCookie('privacyBanner');
var rlxConsentCookie = getCookie('rlx-consent');

/* Check to see if the Privacy Banner has been shown already and if not, we show it.
If the privacyBanner cookie has already been set, we fire the checkRolexCookie()
function to make sure analytics are not tracking. */
if(privacyBannerCookie == undefined || privacyBannerCookie == "false"){
  setRolexConsent(false);
  privacyBanner.style.display = 'block';
  setCookie('privacyBanner', "true", 180);
}

/* Sets the rlx-consent cookie true/false depending on the passed in value.*/
function setRolexConsent(status){
  if(status){
    if(isRolex && (rlxConsentCookie == undefined || rlxConsentCookie == "false")){
      if (typeof _satellite !== 'undefined') {
        _satellite.track("popinactionconsent");
      }
    }
    setCookie('rlx-consent', "true", 180);
    if(isRolex){
      if (typeof _satellite !== 'undefined') {
        _satellite.setVar("Analyticsconsent", "true");
      }
    }
  } else {
    setCookie('rlx-consent', "false", 180);
    if(isRolex){
      if (typeof _satellite !== 'undefined') {
        _satellite.setVar("Analyticsconsent", "false");
      }
    }
  }
}

/* Check the Rolex Cookie for true/false. */
function checkRolexCookie(){
  rlxConsentCookie = getCookie('rlx-consent');
  if(rlxConsentCookie == "true"){
    setRolexConsent(true);
  } else {
    setRolexConsent(false);
  }
}

/* Sets the Privacy Banner to show. */
function showPolicyBanner() {
  privacyBanner.style.display = 'block';
}

/* Adds an eventListener to listen for a click of the "X" button on the Privacy Banner. */
privacyBannerClose.addEventListener("click", function(){
  privacyBanner.style.display = 'none';
});

/* Adds an eventListener to listen for a click of the "Accept" button on the Privacy Banner. That means they DO consent. */
consentAccept.addEventListener("click", function(){
  setRolexConsent(true);
  privacyBanner.style.display = 'none';
});

/* Adds an eventListener to listen for a click of the "Decline" button on the Privacy Banner. That means they DO NOT consent. */
consentDecline.addEventListener("click", function(){
  setRolexConsent(false);
  privacyBanner.style.display = 'none';
});

/* If the Cookie Consent Link is present (visible on website Privacy Policy page), it will add an event listener to it */
if(updateCookieConsentLink){
  updateCookieConsentLink.addEventListener("click", showPolicyBanner);
}